"use strict";
// NB: Start all routes must follow:
// - forward slash at the beginning
// - lowercase words
// - using dashes(hyphens) for multiple words
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIGNED_DOCUMENTS_ROUTE = exports.ESIG_VALIDATION_ROUTE = exports.INBOX_ROUTE = exports.FACETEC_ROUTE = exports.MY_ACCOUNT_ROUTE = exports.DOCUMENT_SHARE_ROUTE = exports.TEMPLATES_ROUTE = exports.DOCUMENTS_ROUTE = exports.DOCUMENT_ROUTE = exports.PREVIEW_DOCUMENT_ROUTE = exports.CREATE_DOCUMENT_ROUTE = exports.DASHBOARD_ROUTE = exports.CONSOLE_ROUTE = exports.PRIVACY_POLICY_ROUTE = exports.TERMS_AND_CONDITIONS_ROUTE = exports.RESET_PASSWORD_ROUTE = exports.FORGOT_PASSWORD_ROUTE = exports.CREATE_CLIENT_ROUTE = exports.OTP_ROUTE = exports.SIGN_UP_ROUTE = exports.LOG_IN_ROUTE = exports.WELCOME_ROUTE = void 0;
// ENTRY ROUTES > //
exports.WELCOME_ROUTE = "/welcome";
exports.LOG_IN_ROUTE = "/log-in";
exports.SIGN_UP_ROUTE = "/sign-up";
exports.OTP_ROUTE = "/otp";
exports.CREATE_CLIENT_ROUTE = "/create-client";
exports.FORGOT_PASSWORD_ROUTE = "/forgot-password";
exports.RESET_PASSWORD_ROUTE = "/reset-password";
exports.TERMS_AND_CONDITIONS_ROUTE = "/terms-and-conditions";
exports.PRIVACY_POLICY_ROUTE = "/privacy-policy";
// CONSOLE ROUTES >
exports.CONSOLE_ROUTE = "/console";
exports.DASHBOARD_ROUTE = "/dashboard";
exports.CREATE_DOCUMENT_ROUTE = "/create-document";
exports.PREVIEW_DOCUMENT_ROUTE = "/preview-document";
exports.DOCUMENT_ROUTE = "/document";
exports.DOCUMENTS_ROUTE = "/documents";
exports.TEMPLATES_ROUTE = "/templates";
exports.DOCUMENT_SHARE_ROUTE = "/document-share";
exports.MY_ACCOUNT_ROUTE = "/my-account";
exports.FACETEC_ROUTE = "/face-tec";
exports.INBOX_ROUTE = "/inbox";
exports.ESIG_VALIDATION_ROUTE = "/esig-validation";
exports.SIGNED_DOCUMENTS_ROUTE = "/signed-documents";
